import React from "react";
import { Tab } from "semantic-ui-react";
import PdfForm from "./PdfForm";

const FormTab = ({ formName }) => {
  const panes = [
    {
      menuItem: "Primary",
      render: () => (
        <Tab.Pane attached={false}>
          <PdfForm type="primary" formName={formName} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Secondary",
      render: () => (
        <Tab.Pane attached={false}>
          <PdfForm type="secondary" formName={formName} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Interpreter",
      render: () => (
        <Tab.Pane attached={false}>
          <PdfForm type="interpreter" formName={formName} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Preparer",
      render: () => (
        <Tab.Pane attached={false}>
          <PdfForm type="preparer" formName={formName} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Tab
      menu={{ fluid: true, vertical: false, tabular: "top" }}
      panes={panes}
    />
  );
};

export default FormTab;
